/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GeoElectricMeasurement } from "./GeoElectricMeasurement";
import {
  GeoElectricMeasurementFromJSON,
  GeoElectricMeasurementFromJSONTyped,
  GeoElectricMeasurementToJSON,
  GeoElectricMeasurementToJSONTyped,
} from "./GeoElectricMeasurement";

/**
 *
 * @export
 * @interface ApiFrdGeoelectricmeasurementsList200Response
 */
export interface ApiFrdGeoelectricmeasurementsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiFrdGeoelectricmeasurementsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiFrdGeoelectricmeasurementsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiFrdGeoelectricmeasurementsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GeoElectricMeasurement>}
   * @memberof ApiFrdGeoelectricmeasurementsList200Response
   */
  results: Array<GeoElectricMeasurement>;
}

/**
 * Check if a given object implements the ApiFrdGeoelectricmeasurementsList200Response interface.
 */
export function instanceOfApiFrdGeoelectricmeasurementsList200Response(
  value: object
): value is ApiFrdGeoelectricmeasurementsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiFrdGeoelectricmeasurementsList200ResponseFromJSON(
  json: any
): ApiFrdGeoelectricmeasurementsList200Response {
  return ApiFrdGeoelectricmeasurementsList200ResponseFromJSONTyped(json, false);
}

export function ApiFrdGeoelectricmeasurementsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiFrdGeoelectricmeasurementsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GeoElectricMeasurementFromJSON),
  };
}

export function ApiFrdGeoelectricmeasurementsList200ResponseToJSON(
  json: any
): ApiFrdGeoelectricmeasurementsList200Response {
  return ApiFrdGeoelectricmeasurementsList200ResponseToJSONTyped(json, false);
}

export function ApiFrdGeoelectricmeasurementsList200ResponseToJSONTyped(
  value?: ApiFrdGeoelectricmeasurementsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GeoElectricMeasurementToJSON),
  };
}
